export const BackgroundGradient = () => (
  <>
    <img
      src='/gradient.png'
      alt=''
      className='absolute top-0 bottom-0 left-0 z-0 h-full select-none whitespace-nowrap landing-gradient'
    />
  </>
)
